import _ from "lodash"

export default function TypeCheckbox({ value }) {
  if (Array.isArray(value)) {
    return (
      <div>
        <ul style={{ padding: "0px" }}>
          {value.map((val, idx) => (
            <li key={idx} >
              {val}
            </li>
          ))}
        </ul>
      </div>
    )
  }

  return <div>{value ? _.toString(value) : "N/A"} </div>
}
